const FetchProjectTasks = {
	Request: 'FetchProjectTasksActionRequest',
	Success: 'FetchProjectTasksActionSuccess',
	Failure: 'FetchProjectTasksActionFailure'
};

const GetProjectTask = {
	Request: 'GetProjectTaskActionRequest',
	Success: 'GetProjectTaskActionSuccess',
	Failure: 'GetProjectTaskActionFailure'
}

const SearchProjectTasks = {
	Request: 'SearchProjectTasksActionRequest',
	Success: 'SearchProjectTasksActionSuccess',
	Failure: 'SearchProjectTasksActionFailure'
};

function fetchProjectTasks(filter) {
	return {
		type: FetchProjectTasks.Request,
		payload: filter
	};
}

function getProjectTask(id) {
	return {
		type: GetProjectTask.Request,
		payload: id
	}
}

function searchProjectTasks(filter) {
	return {
		type: SearchProjectTasks.Request,
		payload: filter
	};
}

export const ProjectTaskActionCreators = {
	fetchProjectTasks,
	getProjectTask,
	searchProjectTasks
};

export const ProjectTaskActions = {
	FetchProjectTasks,
	GetProjectTask,
	SearchProjectTasks
};
